module.exports = __webpack_public_path__ + "img/sprite.517fb1d7.jpg";